module.exports = __webpack_public_path__ + "static/img/subcontract2.aa787a15.png";